import React from 'react';
import {observer} from 'mobx-react';
import {Modal} from 'components/modals';
import {EmployeeNameWithAvatar, Spinner} from 'components';
import {useFetchModels} from 'shared/hooks';
import {endpoints, types} from 'shared/core';
import {Employee} from 'stores/employees';

const AnnouncementVisibilityModal = observer(({uiState}) => {
  const {announcementVisibilityModalOpen, announcement} = uiState;
  const [employees, isLoading] = useFetchModels(
    announcementVisibilityModalOpen && endpoints.ANNOUNCEMENT.EMPLOYEES.with(announcement.id),
    types.EMPLOYEE,
    Employee
  );

  return (
    <Modal
      size='sm'
      isOpen={announcementVisibilityModalOpen}
      title='hr_dashboard.feed.announcements.Announcement Visibility'
      onHide={() => uiState.closeAnnouncementVisibilityModal()}
    >
      {isLoading && <Spinner/>}
      {announcementVisibilityModalOpen && !isLoading && employees.map(employee => <div className='my1'>
          <EmployeeNameWithAvatar employee={employee}/>
        </div>
      )}
    </Modal>
  );
});

export default AnnouncementVisibilityModal;
